












import React from 'react';

const ActivitiesSection = () => {
  return (
    <>
      {/* 🌿 Page Banner */}
<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>Features & Activities</h1>
    </div>
  </div>
</section>


  

      {/* 🌳 Features Section */}
      <section className="activities-section light-bg mx-60 border-shape-top">
        <div className="auto-container">
          <h2 className="sec-title">
            Experience Comfort, Luxury & Nature at Woodland Escape 
          </h2>

          <div className="top-text mb_40">
            <div className="row">
              <div className="col-lg-6">
                <div className="text">
                  Woodland Escape  offers a unique blend of luxury living and natural beauty. 
                  Every corner is designed to provide our guests with privacy, comfort, and a deep connection 
                  to the serene forest surroundings — making it an ideal destination for couples, families, 
                  and adventure seekers.
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ps-lg-5 pe-lg-5">
                  <div className="text">
                    From our private villa and pool to the elevated Machan tower and personalized dining, 
                    each experience at Woodland Escape is crafted to create unforgettable memories 
                    in the heart of nature.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 🏞️ Features Grid */}
          <div className="row">
            {/* Villa */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="/images/galleryy/23.jpg" alt="Woodland Escape  Villa" />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Stay Experience</div>
                  <h5>Luxury 2 BHK Villa</h5>
                  <div className="text-three">
                   The fully airconditioned 2 BHK villa features a Hall, 2 bedrooms & 2 lavish bathrooms fully equipped with toiletries with wet and dry area for your comfort. An additional open-air bathroom lets you enjoy the skies with complete privacy that makes it a perfect suite for honeymooners.
                  </div>
                </div>
              </div>
            </div>

            {/* Swimming Pool */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="images/water.jpg" alt="Private Swimming Pool at Woodland Escape " />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Water Fun</div>
                  <h5>Private Swimming Pool</h5>
                  <div className="text-three">
                    The property incorporates a 50-feet private swimming pool that comes with a baby pool so you can keep a constant watch on your naughty toddlers while you enjoy your swim with complete privacy.
                  </div>
                </div>
              </div>
            </div>

            {/* Machan Tower */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="images/animal-watch-tower.jpg" alt="Machan Watch Tower at Woodland Escape " />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Nature Viewpoint</div>
                  <h5>20 Feet Machan Tower</h5>
                  <div className="text-three">
                    A 20-feet high Watch Tower overlooking the river and the edge of the forest allows you to spot wild animals effortlessly in quiet comfort. If you’re lucky enough you could even spot a leopard or a tiger.
                  </div>
                </div>
              </div>
            </div>

            {/* Food & Services */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="/images/foodservice.jpg" alt="Food and Barbecue at Woodland Escape " />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Food & Service</div>
                  <h5>Homely Food & Service</h5>
                  <div className="text-three">
                    There are four fully experienced in-house care takers, including a butler, who would serve you delicious breakfast, lunch, snacks and dinner.
                  </div>
                </div>
              </div>
            </div>

            {/* Taxi & Travel */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="/images/taxi.jpg" alt="Taxi and Travel Assistance Woodland Escape " />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Travel Support</div>
                  <h5>Taxi & Travel Assistance</h5>
                  <div className="text-three">
                    Taxis with professional drivers can be arranged from Nagpur railway station and Nagpur Airport at an extra cost. Pickup from the property to safari gates are also available.
                  </div>
                </div>
              </div>
            </div>

            {/* Safari Assistance */}
            <div className="col-lg-6">
              <div className="inner-box">
                <div className="image">
                  <img src="/images/safarii.avif" alt="Safari Booking Assistance Woodland Escape " />
                </div>
                <div className="lower-contant">
                  <div className="text-two">Adventure</div>
                  <h5>Safari Booking Assistance</h5>
                  <div className="text-three">
                  We can assist you with safari bookings on the official government website (Although we do not guarantee any confirmed bookings)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ActivitiesSection;
